// ─────────────────────────────────────────────
//  CENTRAL CONFIG — edit this file to swap clients
// ─────────────────────────────────────────────
export const siteConfig = {
  // ── Chat Widget ──────────────────────────────────────────────────────────
  // Paste the contractor's chat widget embed details here.
  // src:   the script src URL from their chat platform embed code
  // attrs: any data-* attributes the script tag needs (key → value)
  // Leave src as "" to disable the widget entirely.
  //
  // GoHighLevel / LeadConnector example:
  //   src: "https://beta.leadconnectorhq.com/loader.js",
  //   attrs: {
  //     "data-resources-url": "https://beta.leadconnectorhq.com/chat-widget/loader.js",
  //     "data-widget-id": "PASTE_WIDGET_ID_HERE",
  //   },
  chatWidget: {
    src: "https://widgets.leadconnectorhq.com/loader.js",
    attrs: {
      "data-resources-url": "https://widgets.leadconnectorhq.com/chat-widget/loader.js",
      "data-widget-id": "6a851efd7ecb78b58d0550bc",
    },
  },

  businessName: "Apply Pressure Washing LLC",
  // Set to "/assets/logo.png" once a real logo file is placed in public/assets/
  // Leave as "" to use the auto-generated SVG mark instead
  logo: "/assets/logo.png",
  // Drop any .ico, .png, or .svg file in public/assets/ and set the path here.
  // Leave as "" to keep the default blank favicon.
  favicon: "",
  // Brand accent icon used throughout the site (eyebrow badges, CTA buttons, section labels).
  // Must match a key in src/utils/icons.js. Common choices: "Droplets", "SprayCan",
  // "Sparkles", "CloudRain", "Home"
  brandIcon: "Droplets",
  phone: "(386) 286-3774",
  phoneHref: "tel:+13862863774",
  // Placeholder — swap for the client's real inbox address once confirmed.
  email: "info@applypressurewashing.com",
  // Full street address (used for reference / schema — display copy lives in ContactPage.jsx)
  streetAddress: "7 3rd Ct, Bunnell, FL 32110",
  city: "Bunnell",
  state: "FL",

  serviceAreas: [
    "Bunnell",
    "Palm Coast",
    "Flagler Beach",
    "Ormond Beach",
    "Daytona Beach",
    "DeLand",
    "St. Augustine",
    "Deltona",
  ],

  colors: {
    primary:     "#1479C9",
    primaryDark: "#0E5A99",
    dark:        "#0B1220",
    light:       "#F4F8FB",
    accent:      "#38BDF8",
  },

  hero: {
    eyebrow: "Pressure Washing • Roof & Gutter Cleaning",
    // The headline is split into two parts — the highlight renders in the brand primary color
    headline: "Restore Your Property's",
    headlineHighlight: "Shine.",
    subheadline:
      "Professional pressure washing, soft washing, and gutter cleaning for homes and businesses across Bunnell and the Flagler County area. From driveways to rooftops — we get it clean and keep it that way.",
    image:
      "/assets/images/hero.png",
    // Primary CTA → contact/quote page
    ctaPrimaryLabel: "Get My Free Quote",
    ctaPrimaryHref: "/contact",
    // Secondary CTA → gallery or any path/url
    ctaSecondaryLabel: "View Our Work",
    ctaSecondaryHref: "/gallery",
  },

  about: {
    headline: "Bunnell's Trusted Pressure Washing & Gutter Cleaning Team",
    // Homepage about section — split headline with a colored middle phrase
    headlineMain:      "Clean You Can",
    headlineHighlight: "Trust,",
    headlineEnd:       "Results You'll Love",
    body: "At Apply Pressure Washing LLC, we believe every property — whether it's a single driveway or a full exterior wash — deserves the same level of care and attention to detail. We're a locally owned pressure washing and gutter cleaning company serving Bunnell and the surrounding Flagler County area with a crew that treats your property like it's our own.",
    body2: "From the first estimate to the final rinse, we handle every detail so you don't have to. No surprises, no shortcuts — just a clean, protected property delivered on schedule.",
    image:
      "/assets/images/about.jpg",
    founded: "2018",
    projectsCompleted: "500+",
    yearsExperience: "7+",
    overlayCard: {
      icon: "ShieldCheck",
      title: "Licensed & Insured",
      sub: "Fully credentialed in Florida. Every property covered, no exceptions.",
    },
    values: [
      { icon: "SprayCan",    title: "Quality Care",          body: "We use proven techniques and properly maintained equipment on every property — residential or commercial." },
      { icon: "Users",       title: "Clear Communication",   body: "You'll always know where your project stands. We return calls, send updates, and keep you in the loop." },
      { icon: "ShieldCheck", title: "Licensed & Insured",    body: "Fully insured so you're protected from day one, on every job we take on." },
      { icon: "ThumbsUp",    title: "On Time, Every Time",   body: "We set realistic schedules, stick to them, and flag any changes before they become surprises." },
    ],
  },

  services: [
    {
      name: "House Washing",
      slug: "house-washing",
      icon: "Home",
      shortDescription:
        "Safe, low-pressure soft washing that removes dirt, mold, and mildew without damaging your siding.",
      description:
        "Florida's heat and humidity make homes a magnet for algae, mold, and mildew buildup. We use soft wash techniques — low pressure combined with the right cleaning solution — to safely remove buildup from siding, stucco, and brick without damaging your exterior. The result is a noticeably brighter, healthier-looking home.",
      benefits: [
        "Safe for vinyl, stucco, brick, and painted surfaces",
        "Removes algae, mold, mildew, and dirt buildup",
        "Improves curb appeal and protects exterior finishes",
        "Low-pressure process — no risk of siding damage",
      ],
      commonProjects: [
        "Full exterior house washing",
        "Pre-sale curb appeal cleaning",
        "Stucco and brick soft washing",
        "Spot treatment for algae and mildew stains",
      ],
      image:
        "/assets/images/service-house-washing.jpg",
    },
    {
      name: "Driveway & Concrete Cleaning",
      slug: "driveway-concrete-cleaning",
      icon: "Layers",
      shortDescription:
        "High-pressure cleaning that lifts oil stains, mildew, and grime from driveways, walkways, and patios.",
      description:
        "Concrete surfaces take a beating from tire marks, oil stains, and Florida's humidity-fed algae growth. Our high-pressure cleaning restores driveways, walkways, sidewalks, and patios to a like-new look, and we offer optional sealing to help keep them cleaner longer.",
      benefits: [
        "Removes oil stains, tire marks, and ground-in dirt",
        "Eliminates slippery algae and mildew buildup",
        "Improves curb appeal and safety underfoot",
        "Optional sealing available to extend results",
      ],
      commonProjects: [
        "Residential driveway cleaning",
        "Walkway and sidewalk cleaning",
        "Pool deck and patio cleaning",
        "Commercial parking lot and sidewalk cleaning",
      ],
      image:
        "/assets/images/service-driveway-concrete-cleaning.jpg",
    },
    {
      name: "Roof Soft Washing",
      slug: "roof-soft-washing",
      icon: "CloudRain",
      shortDescription:
        "Low-pressure roof cleaning that removes black streaks and algae without damaging shingles or tile.",
      description:
        "Those black streaks on Florida roofs aren't dirt — they're algae. High pressure can damage shingles, so we use a soft wash method with a roof-safe cleaning solution to kill algae at the root and rinse it away gently, extending the life of your roof and restoring its appearance.",
      benefits: [
        "Roof-safe soft wash process — no shingle damage",
        "Kills algae, moss, and lichen at the root",
        "Extends roof lifespan by removing damaging growth",
        "Noticeably improves curb appeal and home value",
      ],
      commonProjects: [
        "Shingle roof algae and black streak removal",
        "Tile roof cleaning",
        "Pre-sale roof cleaning",
        "Moss and lichen treatment",
      ],
      image:
        "/assets/images/service-roof-soft-washing.jpg",
    },
    {
      name: "Gutter Cleaning",
      slug: "gutter-cleaning",
      icon: "Droplets",
      shortDescription:
        "Full gutter and downspout cleaning that keeps water flowing away from your home instead of into it.",
      description:
        "Clogged gutters can lead to roof leaks, fascia rot, and foundation damage — especially during Florida's rainy season. We clear leaves, debris, and buildup from gutters and downspouts and check that everything is draining properly, so you're protected before the next storm.",
      benefits: [
        "Prevents water damage to roof, fascia, and foundation",
        "Clears clogs from gutters and downspouts",
        "Reduces pest and mosquito breeding grounds",
        "Debris removed and hauled away every visit",
      ],
      commonProjects: [
        "Routine seasonal gutter cleaning",
        "Pre-storm season gutter clear-outs",
        "Downspout clog removal",
        "Gutter flush and flow testing",
      ],
      image:
        "/assets/images/service-gutter-cleaning.jpg",
    },
    {
      name: "Deck & Fence Cleaning",
      slug: "deck-fence-cleaning",
      icon: "Layers",
      shortDescription:
        "Restore wood and composite decks, fences, and outdoor structures with a thorough, surface-safe wash.",
      description:
        "Outdoor wood and composite surfaces build up grime, mildew, and gray weathering over time. We clean decks, fences, and other outdoor structures with pressure and chemical treatments matched to the material, bringing back their original color and preparing them for staining or sealing if needed.",
      benefits: [
        "Restores natural color to wood and composite decking",
        "Removes mildew, algae, and weathered gray buildup",
        "Prepares surfaces for staining or sealing",
        "Pressure adjusted by material to avoid damage",
      ],
      commonProjects: [
        "Wood deck cleaning and restoration",
        "Composite deck cleaning",
        "Fence washing",
        "Pergola and outdoor structure cleaning",
      ],
      image:
        "/assets/images/service-deck-fence-cleaning.jpg",
    },
    {
      name: "Commercial Pressure Washing",
      slug: "commercial-pressure-washing",
      icon: "Building2",
      shortDescription:
        "Storefronts, sidewalks, and parking lots cleaned on a schedule that works around your business hours.",
      description:
        "First impressions matter for any business. We provide commercial pressure washing for storefronts, sidewalks, parking lots, and building exteriors, with flexible scheduling — including early morning or after-hours service — to minimize disruption to your operations.",
      benefits: [
        "Flexible scheduling around business hours",
        "Improves customer first impressions",
        "Removes gum, stains, and grime from high-traffic areas",
        "Recurring maintenance plans available",
      ],
      commonProjects: [
        "Storefront and entryway cleaning",
        "Parking lot and sidewalk washing",
        "Commercial building exterior washing",
        "Dumpster pad and loading area cleaning",
      ],
      image:
        "/assets/images/service-commercial-pressure-washing.jpg",
    },
  ],

  gallery: [
    "/assets/images/gallery-1.jpg",
    "/assets/images/gallery-2.jpg",
    "/assets/images/gallery-3.jpg",
    "/assets/images/gallery-4.jpg",
    "/assets/images/gallery-5.jpg",
    "/assets/images/gallery-6.jpg",
    "/assets/images/gallery-7.jpg",
    "/assets/images/gallery-8.jpg",
    "/assets/images/gallery-9.jpg",
    "/assets/images/gallery-10.jpg",
    "/assets/images/gallery-11.jpg",
    "/assets/images/gallery-12.jpg",
    "/assets/images/gallery-13.jpg",
    "/assets/images/gallery-14.jpg",
    "/assets/images/gallery-15.jpg",
    "/assets/images/gallery-16.jpg",
    "/assets/images/gallery-17.jpg",
  ],

  reviews: [
    {
      name: "Karen L.",
      location: "Bunnell, FL",
      rating: 5,
      text: "Apply Pressure Washing cleaned our driveway and it looks brand new. The oil stains that have been there for years are completely gone. Fast, professional, and reasonably priced.",
    },
    {
      name: "Mike S.",
      location: "Palm Coast, FL",
      rating: 5,
      text: "They soft washed our entire house and roof. The black streaks on the roof are gone and the siding looks like the day we moved in. Great communication throughout the whole process.",
    },
    {
      name: "Denise R.",
      location: "Flagler Beach, FL",
      rating: 5,
      text: "Had them clean our gutters before hurricane season and they found a clog we didn't even know about. Glad we called before it became a bigger problem. Will be a repeat customer.",
    },
    {
      name: "Anthony B.",
      location: "Ormond Beach, FL",
      rating: 5,
      text: "Our pool deck and patio were covered in algae and looked dangerous to walk on. One visit and it's spotless. Showed up on time and cleaned up after themselves too.",
    },
    {
      name: "Sharon W.",
      location: "Daytona Beach, FL",
      rating: 5,
      text: "We hired them for our storefront and sidewalk on a recurring schedule. Always reliable, always thorough, and it makes a real difference for our customers walking in.",
    },
    {
      name: "Jason T.",
      location: "DeLand, FL",
      rating: 5,
      text: "Great job on our wood deck — it looks freshly stained even though all they did was clean it. Fair pricing and they explained exactly what they were going to do beforehand.",
    },
  ],

  faqs: [
    {
      q: "What areas do you service?",
      a: `We're based in Bunnell, FL and proudly serve ${["Bunnell", "Palm Coast", "Flagler Beach", "Ormond Beach", "Daytona Beach", "DeLand", "St. Augustine", "Deltona"].join(", ")} and surrounding communities. Not sure if we cover your area? Give us a call.`,
    },
    {
      q: "Do you offer free estimates?",
      a: "Yes — all estimates are completely free. We'll take a look at your property, discuss what you need cleaned, and provide a detailed quote with no pressure and no obligation.",
    },
    {
      q: "Are you licensed and insured?",
      a: "Yes. Apply Pressure Washing LLC is fully insured, and we're happy to provide documentation before any work begins so you have complete peace of mind.",
    },
    {
      q: "What's the difference between pressure washing and soft washing?",
      a: "Pressure washing uses high water pressure and works well on tough surfaces like concrete and pavers. Soft washing uses low pressure combined with a cleaning solution, and is the safer method for roofs, siding, and other delicate surfaces where high pressure could cause damage. We use whichever method is right for the surface.",
    },
    {
      q: "How often should I have my gutters cleaned?",
      a: "Most Florida homes benefit from gutter cleaning at least twice a year — once before the rainy/hurricane season and once after leaf drop. Homes with heavy tree coverage may need cleaning more often.",
    },
    {
      q: "How do I get started?",
      a: "Just call us at (386) 286-3774 or fill out the quote form on our site. We'll schedule a time to take a look at your property and get you a free, no-obligation estimate.",
    },
  ],

  trustBar: [
    { icon: "MapPin",      label: "Bunnell, FL" },
    { icon: "Users",       label: "Family Owned" },
    { icon: "Clock",       label: "7+ Years Experience" },
    { icon: "ShieldCheck", label: "Fully Insured" },
    { icon: "BadgeCheck",  label: "Licensed & Insured" },
  ],

  cta: {
    headline: "Ready for a Fresh Clean?",
    sub: "Get a free pressure washing estimate — no pressure, no obligation.",
    buttonLabel: "Get a Free Quote",
    image:
      "/assets/images/cta.jpg",
  },

  // Set to the client's Google Maps / review URL once confirmed. While "#" the
  // "Leave Us a Google Review" button is hidden on the Reviews page.
  googleReviewLink: "#",

  // ─── Before & After Slider ───────────────────────────────────────────────
  // Drop in two photo URLs to enable the Before/After slider on the homepage.
  // Leave `before` or `after` as "" to hide the section entirely.
  beforeAfter: {
    before:
      "/assets/images/before.jpg",
    after:
      "/assets/images/after.jpg",
    heading: "Before & After",
    sub:
      "See the difference our team makes — from grimy and stained to spotless and restored. Drag the slider to compare.",
  },

  // ─── Blog ────────────────────────────────────────────────────────────────
  // Each post: slug (URL key), title, excerpt, content blocks.
  // Block types: { type: "p", text: "..." } | { type: "h2", text: "..." } | { type: "ul", items: [...] }
  // Add, remove, or reorder posts freely. The grid and detail pages adapt automatically.
  blog: {
    eyebrow: "Cleaning Tips",
    heading: "From the Blog",
    sub: "Pressure washing tips, seasonal guides, and property care advice from the Apply Pressure Washing team.",
    posts: [
      {
        slug: "how-often-pressure-wash-house-florida",
        title: "How Often Should You Pressure Wash Your House in Florida?",
        excerpt: "Florida's humidity accelerates algae and mildew growth compared to other states. Here's how often you should really be cleaning your home's exterior.",
        content: [
          { type: "p", text: "Florida homes face a tougher environment than most — high humidity, frequent rain, and intense sun create ideal conditions for algae, mold, and mildew to take hold fast. Knowing how often to clean keeps your home looking sharp and prevents buildup from causing lasting damage." },
          { type: "h2", text: "The General Rule" },
          { type: "p", text: "Most Florida homes benefit from a full exterior wash once a year. Homes in shaded, humid areas, or those close to the coast with salt air exposure, may need cleaning every 6-9 months to stay ahead of buildup." },
          { type: "h2", text: "Signs Your Home Needs Cleaning Sooner" },
          { type: "ul", items: [
            "Black or green streaks appearing on siding or roof",
            "A dull, grayish tint replacing your home's original color",
            "Visible algae or mildew in shaded, north-facing areas",
            "Musty odor near exterior walls or under eaves",
          ]},
          { type: "h2", text: "Why Waiting Too Long Costs More" },
          { type: "p", text: "Algae and mildew don't just look bad — left long enough, they can degrade paint, stucco, and siding, turning a routine cleaning into a repair project. Regular washing is far cheaper than replacing damaged exterior surfaces." },
          { type: "h2", text: "Let Us Take a Look" },
          { type: "p", text: "Not sure if your home is due? We offer free estimates and can tell you honestly whether it's time for a wash. Contact us to schedule yours." },
        ],
      },
      {
        slug: "soft-washing-vs-pressure-washing",
        title: "Soft Washing vs. Pressure Washing: What's the Difference?",
        excerpt: "Not every surface should be cleaned the same way. Here's how to know which method is right for your project.",
        content: [
          { type: "p", text: "'Pressure washing' gets used as a catch-all term, but there are actually two distinct methods — and using the wrong one on the wrong surface can cause real damage. Here's the difference." },
          { type: "h2", text: "Pressure Washing" },
          { type: "p", text: "Pressure washing uses high-force water alone to blast away dirt, stains, and grime. It's ideal for tough, durable surfaces like concrete driveways, pavers, and brick — surfaces that can handle the force without being damaged." },
          { type: "h2", text: "Soft Washing" },
          { type: "p", text: "Soft washing uses low water pressure combined with a specialized cleaning solution that kills algae, mold, and mildew at the root, then rinses it away gently. This method is used on surfaces that high pressure could damage — roofs, siding, stucco, and painted surfaces." },
          { type: "h2", text: "Which Method for Which Surface?" },
          { type: "ul", items: [
            "Concrete driveways and sidewalks — pressure washing",
            "Roofs (shingle or tile) — soft washing only",
            "Vinyl or stucco siding — soft washing",
            "Pavers and pool decks — pressure washing",
            "Wood decks and fences — pressure adjusted to material, sometimes combined with soft wash treatment",
          ]},
          { type: "h2", text: "We Use the Right Tool for the Job" },
          { type: "p", text: "Every property is different, which is why we assess each surface before starting. Contact us for a free estimate and we'll recommend the right approach for your project." },
        ],
      },
      {
        slug: "why-gutter-cleaning-matters-before-hurricane-season",
        title: "Why Gutter Cleaning Matters Before Hurricane Season",
        excerpt: "Clogged gutters are one of the most overlooked risks heading into Florida's storm season. Here's what can go wrong — and how to prevent it.",
        content: [
          { type: "p", text: "As hurricane season approaches, most homeowners think about boarding windows and securing outdoor furniture. Gutters rarely make the list — but clogged gutters can cause serious damage when heavy rain hits." },
          { type: "h2", text: "What Happens When Gutters Are Clogged" },
          { type: "p", text: "When leaves and debris block the flow, rainwater has nowhere to go but over the edge — right down your siding, foundation, and landscaping. Over time, this can lead to fascia rot, foundation erosion, and even roof leaks as water backs up under shingles." },
          { type: "h2", text: "The Best Time to Clean" },
          { type: "p", text: "Late spring, just before hurricane season ramps up in June, is the ideal window. A second cleaning in fall after leaf drop keeps gutters clear through the rest of the year." },
          { type: "h2", text: "What a Proper Cleaning Includes" },
          { type: "ul", items: [
            "Full removal of leaves, debris, and buildup from gutters",
            "Downspout clearing to confirm water flows all the way through",
            "A flow test to catch any hidden clogs or damage",
            "Debris hauled away — not left in your yard",
          ]},
          { type: "h2", text: "Get Ahead of the Season" },
          { type: "p", text: "We help homeowners across Flagler County get their gutters storm-ready every year. Contact us to schedule your pre-season cleaning." },
        ],
      },
      {
        slug: "black-streaks-on-roof-what-they-are",
        title: "Those Black Streaks on Your Roof Aren't Dirt — Here's What They Really Are",
        excerpt: "If your roof has dark streaks running down the shingles, it's not just dirt buildup. Here's what's actually happening and why it matters.",
        content: [
          { type: "p", text: "Almost every Florida homeowner has seen it — dark streaks running down a roof, usually starting near the ridge. Most people assume it's dirt or soot. It's actually a type of algae, and it's more than a cosmetic issue." },
          { type: "h2", text: "Meet Gloeocapsa Magma" },
          { type: "p", text: "The black streaks are caused by a blue-green algae called Gloeocapsa magma. It thrives in humid, warm climates — which makes Florida roofs a prime target. The algae feeds on the limestone filler in asphalt shingles, gradually spreading across the roof." },
          { type: "h2", text: "Why It's More Than a Cosmetic Problem" },
          { type: "p", text: "Beyond looking bad, the algae can trap moisture against the shingles, reduce their reflectivity (which can raise cooling costs), and shorten the lifespan of your roof if left untreated for years." },
          { type: "h2", text: "Why You Shouldn't Pressure Wash a Roof" },
          { type: "p", text: "High-pressure washing can strip the protective granules off shingles, causing damage that shortens your roof's life and can void manufacturer warranties. That's why roof cleaning should always be done with a soft wash method." },
          { type: "h2", text: "The Soft Wash Solution" },
          { type: "p", text: "We use a low-pressure application with a roof-safe cleaning solution that kills the algae at the root and rinses away safely, restoring your roof's appearance without risking damage. Contact us for a free roof cleaning estimate." },
        ],
      },
      {
        slug: "boost-curb-appeal-before-selling",
        title: "Selling Your Home? Here's Why Pressure Washing Should Be Step One",
        excerpt: "Before you spend money on staging or landscaping, a full exterior wash is often the highest-return prep step for selling your home.",
        content: [
          { type: "p", text: "First impressions happen before a buyer ever steps inside. If your driveway, siding, and walkways are covered in Florida's typical algae and grime buildup, it undercuts everything else you've done to prepare your home for sale." },
          { type: "h2", text: "Why It's One of the Best-ROI Prep Steps" },
          { type: "p", text: "Studies on home prep consistently rank exterior cleaning among the highest return-on-investment improvements — often outperforming more expensive updates. It's inexpensive relative to the visual impact it creates." },
          { type: "h2", text: "What to Prioritize Before Listing" },
          { type: "ul", items: [
            "Driveway and walkway pressure washing — removes stains that stand out in listing photos",
            "House soft washing — brightens siding and removes algae streaking",
            "Roof soft washing — eliminates the dark streaks buyers notice immediately",
            "Deck and patio cleaning — makes outdoor living space photograph well",
          ]},
          { type: "h2", text: "Timing It Right" },
          { type: "p", text: "Schedule your cleaning 1-2 weeks before listing photos are taken, giving surfaces time to fully dry and any treated algae time to finish lifting." },
          { type: "h2", text: "Ready to List?" },
          { type: "p", text: "We work with homeowners and realtors across Flagler County to get properties market-ready. Contact us for a free estimate before your next listing." },
        ],
      },
    ],
  },

  // ─── Services Section (homepage) ────────────────────────────────────────
  servicesSection: {
    intro: "From driveways to rooftops, we deliver complete pressure washing and gutter cleaning services built for Florida's climate, on schedule, and done right.",
    footerTagline: "We handle a full range of residential and commercial exterior cleaning — tailored to your property, your schedule, and your budget.",
  },

  // ─── Service Area Detail Pages ────────────────────────────────────────
  serviceAreaPage: {
    heroSub: "Top-rated pressure washing and gutter cleaning services. Local team, quality results, free estimates.",
    bodyIntro: "has been proudly serving homeowners and businesses with full-service pressure washing and gutter cleaning — house washing, roof cleaning, driveways, and more. Our team delivers reliable, quality results tailored to each property.",
    bodySecondary: "Whether you need a one-time deep clean or recurring maintenance, our local crew is ready to help. We offer free, no-obligation estimates and stand behind every job we complete.",
  },

  social: {
    google:    "#",   // paste your Google Business Profile URL
    instagram: "#",   // paste your Instagram profile URL
    facebook:  "#",   // paste your Facebook page URL — leave "" to hide
  },

  hours: [
    { day: "Mon", time: "8:00AM – 5:00PM" },
    { day: "Tue", time: "8:00AM – 5:00PM" },
    { day: "Wed", time: "8:00AM – 5:00PM" },
    { day: "Thu", time: "8:00AM – 5:00PM" },
    { day: "Fri", time: "8:00AM – 5:00PM" },
    { day: "Sat", time: "8:00AM – 2:00PM" },
    { day: "Sun", time: "Closed" },
  ],

  // ─── FAQ + Service Areas section background ──
  // Photo URL shown behind the floating white wave section.
  // Swap for any image URL. Set "" to use the solid brand dark color instead (recommended).
  faqAreasBgImage: "",

  // ─── Google My Maps embed ────────────────────
  // 1. Go to Google My Maps → Share → Embed on my site
  // 2. Copy the src="..." URL from the <iframe> tag and paste it below
  // Leave as "" to hide the map and show a placeholder instead
  mapEmbedUrl: "",

  // ─── GoHighLevel Popup Form ───────────────────
  // Paste your GHL form PAGE URL (not embed code) here.
  // When set, the quote popup shows a GHL iframe instead of the native form.
  // Leave as "" to use the built-in native form.
  ghlPopupFormUrl: "",

  // ─── GoHighLevel Inline Embed (hero + contact page) ──
  // Paste your GHL embed code inside: src/components/QuoteFormEmbed.jsx
  ghlFormEmbed: "",

  // ─── Lead intake endpoint (serverless → GoHighLevel, NO premium fees) ──────
  // The quote form POSTs here (same-origin). Handled by the Cloudflare Pages
  // function at frontend/functions/api/lead.js, which creates the contact in
  // GoHighLevel via the standard (free) API — no iframe, no premium webhook.
  //
  // Per-client setup (Pages host → Settings → Environment variables):
  //   GHL_API_KEY      = sub-account Private Integration Token (pit-…)
  //   GHL_LOCATION_ID  = sub-account location ID
  // Then in GHL, trigger "Claude — 01 Speed to Lead" on:
  //   Contact Tag → "form submission lead"   (the function applies this tag)
  //
  // Leave the default unless you host the lead function somewhere else.
  leadEndpoint: "/api/lead",
};
